
import { Project, WbsItem, LogEntry, LogType, LogStatus } from './types';

export const MOCK_PROJECTS: Project[] = [
  {
    id: "p1",
    name: "Terminal 2 Expansion",
    location: "Tumon Bay, Guam",
    contractAmount: 14500000,
    expectedProfit: 2175000, // 15% margin
    costToDate: 6200000,
    unbilledExposure: 420000,
    marginRetentionScore: 84,
    profitVelocity: -12500, // Losing $12.5k profit/mo
    marginStatus: "Yellow",
    description: "Major renovation and expansion of the main airport terminal including seismic retrofitting.",
    marginTrajectory: [
      { month: 'Jan', expectedProfit: 2175000, actualProfit: 2175000, forecastedProfit: 2175000 },
      { month: 'Feb', expectedProfit: 2175000, actualProfit: 2160000, forecastedProfit: 2150000 },
      { month: 'Mar', expectedProfit: 2175000, actualProfit: 2140000, forecastedProfit: 2100000 },
      { month: 'Apr', expectedProfit: 2175000, actualProfit: 2100000, forecastedProfit: 1950000 },
      { month: 'May', expectedProfit: 2175000, actualProfit: 2050000, forecastedProfit: 1825000 },
    ],
    subcontractorImpacts: [
      { name: "Pacific Rebar", status: "OnTrack", variance: -5200 },
      { name: "Island Plumbing", status: "AtRisk", variance: 42000 },
      { name: "Guam Electrical", status: "Delayed", variance: 18000 },
    ],
    // Fix: Added missing properties cpi and forecastAtCompletion
    cpi: 0.94,
    forecastAtCompletion: 14850000,
  },
  {
    id: "p2",
    name: "Pacific Heights Luxury Condos",
    location: "Tamuning, Guam",
    contractAmount: 32000000,
    expectedProfit: 4800000, // 15% margin
    costToDate: 12000000,
    unbilledExposure: 150000,
    marginRetentionScore: 98,
    profitVelocity: 4200, // Gaining $4.2k profit/mo
    marginStatus: "Green",
    description: "Multi-story residential development with deep foundation work.",
    marginTrajectory: [
      { month: 'Jan', expectedProfit: 4800000, actualProfit: 4800000, forecastedProfit: 4800000 },
      { month: 'Feb', expectedProfit: 4800000, actualProfit: 4810000, forecastedProfit: 4820000 },
      { month: 'Mar', expectedProfit: 4800000, actualProfit: 4820000, forecastedProfit: 4850000 },
    ],
    subcontractorImpacts: [
      { name: "Star Foundations", status: "OnTrack", variance: -120000 },
      { name: "Zenith Glass", status: "OnTrack", variance: 0 },
    ],
    // Fix: Added missing properties cpi and forecastAtCompletion
    cpi: 1.05,
    forecastAtCompletion: 31200000,
  }
];

export const MOCK_WBS: WbsItem[] = [
  {
    id: "w1",
    projectId: "p1",
    code: "03.10.020",
    title: "Structural Concrete Foundations",
    description: "Placement and finishing of all structural concrete footings. Includes formwork and rebar installation.",
    scopeType: "Base"
  },
  {
    id: "w2",
    projectId: "p1",
    code: "22.00.000",
    title: "Plumbing Systems",
    description: "Interior sanitary, vent, and domestic water piping.",
    scopeType: "Base"
  }
];

export const MOCK_LOGS: LogEntry[] = [
  {
    id: "l1",
    projectId: "p1",
    date: new Date().toISOString().split('T')[0],
    authorName: "Managing Principal",
    authorRole: "Owner Representative",
    location: "Main Hangar",
    logType: LogType.DISCOVERY,
    text: "Unforeseen site condition: Encountered high-water table during lift station excavation. Requires immediate dewatering and sheet-piling not in original WBS. Delay to sub accruing hourly.",
    tags: ["unforeseen", "margin-risk", "guam-labor-bottleneck"],
    photos: ["https://picsum.photos/400/300?random=5"],
    status: LogStatus.NEW
  }
];
